"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contract = void 0;
const core_1 = require("@ts-rest/core");
const case_contract_1 = require("./case.contract");
const cases_contract_1 = require("./cases.contract");
const health_contract_1 = require("./health.contract");
const hearing_section_contract_1 = require("./hearing-section.contract");
const hearing_sections_contract_1 = require("./hearing-sections.contract");
const hearing_contract_1 = require("./hearing.contract");
const hearings_contract_1 = require("./hearings.contract");
const c = (0, core_1.initContract)();
exports.contract = c.router({
    case: case_contract_1.caseContract,
    cases: cases_contract_1.casesContract,
    health: health_contract_1.healthContract,
    hearingSection: hearing_section_contract_1.hearingSectionContract,
    hearingSections: hearing_sections_contract_1.hearingSectionsContract,
    hearing: hearing_contract_1.hearingContract,
    hearings: hearings_contract_1.hearingsContract,
}, {
    validateResponseOnClient: true,
});
